import { isEmpty } from 'lodash';
import { IInternationalConfig } from '../types/contentful/types.generated';
import { Listing } from '../types/sharetribe/listing';
import { CountryCode, Currency } from '../types/apollo/generated/types.generated';
import { isEUCountry } from './countryCodes';

export interface ReturnShippingPrice {
  price: number;
  currency: Currency;
}

const checkIsEu = (originCountries: string[]) =>
  originCountries.some((countryCode) => isEUCountry(countryCode));

export const doesShopAllowBrandDirectReturns = (
  internationalConfig?: IInternationalConfig,
  returnShippingPrice?: ReturnShippingPrice
) => {
  const allowedOriginToDestinationCountries = Object.keys(
    internationalConfig?.allowedOriginToDestinationCountries || {}
  );

  const isUK = allowedOriginToDestinationCountries.includes(CountryCode.Gb);
  const isEU = checkIsEu(allowedOriginToDestinationCountries);
  const isUKOrEU = isUK || isEU;

  // The UK and EU enforces a 14-day return policy on items sold from brands.
  if (!internationalConfig || !returnShippingPrice) return false;
  const isUKOrEUandHasReturnShippingPrice = isUKOrEU && !isEmpty(returnShippingPrice);

  return isUKOrEUandHasReturnShippingPrice;
};

export const isListingReturnEligible = (
  isBrandDirect: boolean,
  internationalConfig?: IInternationalConfig,
  returnShippingPrice?: ReturnShippingPrice
) => doesShopAllowBrandDirectReturns(internationalConfig, returnShippingPrice) && isBrandDirect;

export const isBundleReturnEligible = (
  bundleListings: Listing[],
  internationalConfig?: IInternationalConfig,
  returnShippingPrice?: ReturnShippingPrice
) => {
  const areAllListingsReturnable =
    !isEmpty(bundleListings) &&
    bundleListings.every((listing) => listing?.attributes.publicData?.isReturnable === true);

  return (
    doesShopAllowBrandDirectReturns(internationalConfig, returnShippingPrice) &&
    areAllListingsReturnable
  );
};
